"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const DialogWrapperWeb_1 = __importDefault(require("./DialogWrapperWeb"));
const TGLazyModalListWeb_1 = __importDefault(require("./TGLazyModalListWeb"));
/**
 * A component that combines DialogWrapper header with lazy list
 * @param props
 */
const TGLazyModalWeb = (props) => {
    const { open, title, filterPlaceHolder, actions, onDone, onCancel, searchText, handleSearchText } = props, modalListProps = __rest(props, ["open", "title", "filterPlaceHolder", "actions", "onDone", "onCancel", "searchText", "handleSearchText"]);
    return (react_1.default.createElement(DialogWrapperWeb_1.default, { title: title, open: open, filterPlaceHolder: filterPlaceHolder, searchText: searchText, handleSearchText: handleSearchText, actions: actions, onCancel: onCancel, onDone: onDone, loading: props.loading },
        react_1.default.createElement(TGLazyModalListWeb_1.default, Object.assign({}, modalListProps, { searchText: searchText }))));
};
exports.default = TGLazyModalWeb;
//# sourceMappingURL=TGLazyModalWeb.js.map